import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { I18nModule, TranslationService } from '@spartacus/core';
import { ToastrService } from 'ngx-toastr';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { CustomLandingModule } from '../../../custom-landing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { MasterData } from 'src/app/core/model/master-data.model';
import { CustomProductsService } from '../../../custom-products/custom-products.service';
import { pairwise } from 'rxjs';
import { InspectionScreeningPopUpComponent } from '../../inspection-screening-pop-up/inspection-screening-pop-up.component';
import { AttachInvoiceComponent } from '../../attach-invoice/attach-invoice.component';
import { PortInvoiceComponent } from '../../port-invoice/port-invoice.component';

@Component({
    selector: 'app-dvl-tracking-list',
    imports: [CustomLandingModule, CommonModule, FormsModule, NgSelectModule, I18nModule, SharedModule, NgSelectModule, RouterModule, InfiniteScrollDirective],
    templateUrl: './dvl-tracking-list.component.html',
    styleUrl: './dvl-tracking-list.component.scss'
})
export class DvlTrackingListComponent implements OnInit {
  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;
  title: any = '';
  navigationData: string = '';
  searchValue: any = null;
  showClear: boolean = false;
  ports = [];
  selectedPort: any;
  selectedStatus: any;
  enableLoader: boolean = true;
  activeTab: string = 'Active';
  shipmentTab: string = 'INPROGRESS:ASSIGNED';
  page = 0;
  searchText = null;
  reachedToEnd: boolean = false;
  listSrc = '/images/list-view-orange.svg';
  gridSrc = '/images/grid-view.svg';
  list = true;
  grid = false;
  dvlTracking: any = []
  code: any = []
  batchesScreening:any=[]
  portData: any[] = [];
  sidebar: boolean;
  portlength = 0;
  statuslength = 0;
  checkedportform: UntypedFormGroup;
  checkedstatusform: UntypedFormGroup;
  length: number;
  display:any;
  fromDetails:any;
  AgentsList: any[] = [];
  StatusList: any[] = [];
  masterData: any;
  enableLoaderScoll:boolean=false;
  loadingData= false;
  section:any;
  isAgentInvoiceActive: string = 'false';
  constructor(private route: ActivatedRoute, private customProductsService: CustomProductsService, private translation: TranslationService, private router: Router, public modalService: NgbModal,
    private toastrService: ToastrService, private customProfileService: CustomProfileService,
    private fb: UntypedFormBuilder) {
    this.checkedportform = this.fb.group({
      checkArray: this.fb.array([])
    });
    this.checkedstatusform = this.fb.group({
      checkArray: this.fb.array([])
    });
  }

  ngOnInit(): void {
     this.customProductsService.returnAgentInvoiceActive().subscribe(res=>{
      this.isAgentInvoiceActive = res;
   })
    this.sidebar = true;
      if(this.router.url.includes('portside')){
      this.section = 'portside';
     } else if(this.router.url.includes('bondedwarehouse')){
      this.section = 'bondedwarehouse';
     }
      this.filter();
    if(this.router.url==='/batches/dvl-tracking-list'||this.router.url==='/batches/dvl-tracking-list?from=details'){
      this.display='delivery';
      this.translation
      .translate('breadcrumb.Batches.pageTitle')
      .subscribe(res => {
        this.title = res;
      });
    this.translation
      .translate('breadcrumb.Batches.breadcrumb')
      .subscribe(res => {
        this.navigationData = res;
      });
      this.getDvlList();
    }
    else if(this.router.url==='/dvl-screening-list/dvl-screening-list/'+ this.section||this.router.url==='/dvl-screening-list/dvl-screening-list/'+ this.section +'?from=details'){
      // this.display='screening';
      this.section=== 'portside'? this.display = 'screening': this.display = 'bondedwarehouseScreening';
     if(this.section === 'portside'){
       this.translation
      .translate('breadcrumb.Screening.pageTitle')
      .subscribe(res => {
        this.title = res;
      });
    this.translation
      .translate('breadcrumb.Screening.breadcrumb')
      .subscribe(res => {
        this.navigationData = res;
      });
     }else if(this.section === 'bondedwarehouse'){
       this.translation
      .translate('breadcrumb.screeningBondedwarehouse.pageTitle')
      .subscribe(res => {
        this.title = res;
      });
    this.translation
      .translate('breadcrumb.screeningBondedwarehouse.breadcrumb')
      .subscribe(res => {
        this.navigationData = res;
      });
     }
     this.getBatchesScreenList();
    }
    setTimeout(() => {      
        this.getMasterData();        
    }, 2000);
    this.customProductsService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
      this.enableLoader = true;
      if (current != null) {
        if (previous !== current) {
          this.enableLoader = true;
          if (this.router.url === '/batches/dvl-tracking-list') {
            this.activeTab = 'Active';
            this.shipmentTab = 'INPROGRESS:ASSIGNED';
            this.getDvlList();
          }
          else if (this.router.url === '/dvl-screening-list/dvl-screening-list/' + this.section) {
            this.activeTab = 'Active';
            this.shipmentTab = 'INPROGRESS:ASSIGNED';
            this.getBatchesScreenList();
          }
          setTimeout(() => {
            this.getMasterData();
          }, 1000);
        }
      }
    });
  }
  filter(){
    this.route.queryParams.subscribe(params=>{
      this.fromDetails=params['from']==='details';
     })
     if(!this.fromDetails){
      this.clearAllFilter();
     }
    this.customProfileService.getports().subscribe((data)=>{
      if(data?.length){
        this.selectedPort = data;
        this.changePorts();
      }
   })
    this.customProfileService.getstatus().subscribe((data)=>{
      if(data?.length){
        this.selectedStatus = data;
        this.changeStatus();
      }
    })
    this.customProfileService.getsearch().subscribe((data)=>{
      if(data?.length){
        this.searchText = data;
      }
    })
    this.customProfileService.getTemplateData().subscribe((tab) => {
      if (tab == 'Active') {
        this.activeTab = 'Active';
        this.shipmentTab = 'INPROGRESS:ASSIGNED';
      }
      else if (tab == 'Completed') {
        this.activeTab = 'Completed'
        this.shipmentTab = 'COMPLETED';
      }
    })

  }
  getMasterData(): void {
    this.enableLoader = true;
    let toastshown=false;
    let pageid='';
    if(this.display === 'delivery'){
      pageid ='DLTRK';
    }else if(this.display === 'screening'){ 
       pageid = 'SCREEN';
    }
        let displaystr;
    // for ports inside filters if want both combined list portside and seabourne then send PS:BW
    this.section === 'bondedwarehouse'? displaystr = 'BW' : displaystr = 'PS';
    this.customProfileService.getShipmentfilters(pageid,displaystr).subscribe((res: MasterData) => {
      if (res) {
        this.enableLoader = false;
        this.masterData = res;
        this.portData = this.masterData.ports;
        this.StatusList = this.masterData.shipmentStatus;
      } (error) => {
        this.enableLoader = false;
        // this.toastrService.show('Something went wrong please contact support team.')
        this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
            toastshown=true;
          }
        })
      }
    });
  }
  // getScreeningMasterData(){
  //   this.enableLoader = true;
  //   let toastshown=false;
  //   this.customProfileService.getScreeningfilters().subscribe((res: MasterData) => {
  //     if (res) {
  //       this.enableLoader = false;
  //       this.masterData = res;
  //       this.portData = this.masterData.ports;
  //       this.StatusList = this.masterData.shipmentStatus;
  //     } (error) => {
  //       this.enableLoader = false;
  //       // this.toastrService.show('Something went wrong please contact support team.')
  //       this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
  //         if(!toastshown){
  //           this.toastrService.show(res);
  //           toastshown=true;
  //         }
  //       })
  //     }
  //   });
  // }
  screenCheck(){
    if(this.display=='delivery'){
      this.getDvlList();
    }else{
      this.getBatchesScreenList();
    }
  }
  getDvlList() {
    this.enableLoader = true;
    this.page = 0;
    let toastshown =false;
    const requestParams = {
      port: this.selectedPort?.length ? this.selectedPort : '',
      currentPage: this.page,
      status: this.selectedStatus?.length ? this.selectedStatus : this.shipmentTab,
    }
    this.customProfileService.dvlTrackingList(requestParams, this.searchText).subscribe((data) => {
      this.dvlTracking = data.batches;
      this.enableLoader = false;
      console.log('dvlTracking', this.dvlTracking);
    }, err => {
      // this.toastrService.show('Batch list having some error.')
      this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
        if(!toastshown){
          this.toastrService.show(res);
          toastshown=true;
        }
      })
      this.enableLoader = false;
    })
  }
  convertDateOnly(dateString): any {
    if (dateString) {
      return dateString.replace(/-/g,'/');
    }
  }
  getBatchesScreenList(){
    this.enableLoader = true;
    this.page = 0;
    let toastshown=false;
    const requestParams = {
      port: this.selectedPort?.length ? this.selectedPort : '',
      currentPage: this.page,
      status: this.selectedStatus?.length ? this.selectedStatus : this.shipmentTab,
    }
    this.customProfileService.batchesScreeningList(requestParams, this.searchText,this.section).subscribe((data)=> {
      this.batchesScreening = data.screeningBatches;
      this.enableLoader = false;
    }, err => {
      this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
        if(!toastshown){
          this.toastrService.show(res);
          toastshown=true;
        }
      })     
      this.enableLoader = false;
    })

  }
  goToDetails(list: any) {  
    this.customProfileService.setports(this.selectedPort);
    this.customProfileService.setstatus(this.selectedStatus);
    this.customProfileService.setsearch(this.searchText);
    this.router.navigate(['batches/dvl-tracking-details/' + list.batchId],{queryParams:{baseProductCode: list.baseProductCode}});
    if(this.activeTab === 'Active'){
      this.customProfileService.setTemplateData('Active');
    }else{
      this.customProfileService.setTemplateData('Completed');  
    }
  }

  changePorts() {
if((this.selectedPort?.length == 0 ||this.selectedPort?.length == undefined) && 
    (this.selectedStatus?.length == 0 ||this.selectedStatus?.length==undefined)){       
      this.showClear = false;
    } else {
      this.showClear = true;
    }
    this.reachedToEnd = false;
    this.screenCheck();
    }

    changeStatus() {
if((this.selectedPort?.length == 0 ||this.selectedPort?.length == undefined) && 
    (this.selectedStatus?.length == 0 ||this.selectedStatus?.length==undefined)){        
       this.showClear = false;
      } else {
        this.showClear = true;
      }
      this.reachedToEnd = false;
       this.screenCheck();
     
    }
  omitSpecialChar(event): any {
    if (this.searchValue?.length >= 2) {
      this.showClear = false;
      // this.selectedPort = null;
      // this.selectedProductType = null;
      // this.selectedProduct = null;
      // this.query = null;
      // this.currentPage = 0;
    }
    const k = event.charCode;
    if (k === 46) {
      return false;
    }
    // return this.isValidLetter(k);
  }
  search() {
    this.searchText.toLowerCase();
    if (this.searchText.length >= 7) {
      this.screenCheck();
    } else if (this.searchText.length == 0) {
      this.customProfileService.resetsearchFilter();
      this.screenCheck();
    }
  }

  clearAllFilter(): any {
    this.showClear = false;
    this.selectedPort = [];
    this.selectedStatus = [];
    this.searchText = null;
    this.customProfileService.resetportFilter();
    this.customProfileService.resetsearchFilter();
    this.customProfileService.resetstatusFilter();
    this.customProfileService.resetTemplateData();
    this.screenCheck();
    }

  getResults(): any {
    this.closebar();
    this.filterData();
  }
  closebar() {
    this.sidebar = true;
  }
  goToScreeningDetails(list){
   // this.router.navigate(['/inventory/batches-screening-details/' + list.batchId],{queryParams:{baseProductCode: list.baseProductCode}});    
   this.customProfileService.setports(this.selectedPort);
   this.customProfileService.setstatus(this.selectedStatus);
   this.customProfileService.setsearch(this.searchText);
    this.router.navigate(['dvl-screening-list/batches-screening/' + list.batchId+'/'+ this.section],{queryParams:{baseProductCode: list.baseProductCode}});
    if(this.activeTab === 'Active'){
      this.customProfileService.setTemplateData('Active');
    }else{
      this.customProfileService.setTemplateData('Completed');  
    }
  }
  filtersidebar() {
    this.sidebar = false;
  }
  filterData() {
    this.enableLoader = true;
    this.screenCheck();
  }
  portsmobileFilter(e, id) {
    this.portlength = 1;
    const checkArray: UntypedFormArray = this.checkedportform.get(
      'checkArray'
    ) as UntypedFormArray;
    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
    }
    else {
      let i = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
      this.portlength = 0;
    }
    this.selectedPort = checkArray.value;
  }
  statusmobileFilter(e, id) {
    this.statuslength = 1;
    const checkArray: UntypedFormArray = this.checkedstatusform.get(
      'checkArray'
    ) as UntypedFormArray;
    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
    }
    else {
      let i = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
      this.statuslength = 0;
    }
    this.selectedStatus = checkArray.value;
  }
  clearFilterDataMobile(event): void {
    this.closebar();
    const checked = false;
    this.portData.forEach(item => (item.selected = checked));
    this.StatusList.forEach(item => (item.selected = checked));
    this.selectedPort = [];
    this.selectedStatus = [];
    this.searchText = null;
    this.screenCheck();
  }

  changeTab(data, showMsg?): any {
    this.enableLoader = true;
    this.activeTab = data;
    this.page = 0;
    this.reachedToEnd = false;
    if (this.activeTab === 'Active') {
      this.shipmentTab = 'INPROGRESS:ASSIGNED';
      this.customProfileService.setTemplateData('Active');
      // show active tab
    }
    else if (this.activeTab === 'Completed') {
      // show completed tab
      this.shipmentTab = 'COMPLETED';
      this.customProfileService.setTemplateData('Completed');

    }
    this.screenCheck();
  }
  viewGrid(): void {
    this.gridSrc = '/images/grid-view-orange.svg';
    this.listSrc = '/images/list-view.svg';
    this.grid = true;
    this.list = false;
  }
  viewList(): any {
    this.listSrc = '/images/list-view-orange.svg';
    this.gridSrc = '/images/grid-view.svg';
    this.list = true;
    this.grid = false;
  }
  onScrollGrid(): any {
    if (!this.loadingData) {
      this.loadMoreData();
    }
    
  }
  loadMoreData(){
    this.loadingData= true;
    // if (!this.reachedToEnd) {
      //this.loaderShow = true;
      // setTimeout(() => {
        //this.enableLoader = true;
        this.page += 1
        const requestParams = {
          port: this.selectedPort?.length ? this.selectedPort : '',
          currentPage: this.page,
          status: this.selectedStatus?.length ? this.selectedStatus : this.shipmentTab,
        }
        let toastshown =false;
        if(this.display=='delivery'){
          this.enableLoaderScoll=true
          this.customProfileService.dvlTrackingList(requestParams, this.searchText).subscribe((data) => {
            this.loadingData= false;
            if (data.batches?.length) {
            this.dvlTracking = this.dvlTracking.concat(data.batches);
            this.enableLoaderScoll = false;
          } else {
            this.reachedToEnd = true;
            this.enableLoaderScoll = false
          }
        }, err => {
          // this.toastrService.show('Batch list is having some error.')
          this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
            if(!toastshown){
              this.toastrService.show(res)
              toastshown=true;
            }
          })
          this.enableLoaderScoll = false;
        })
      }else{
        this.enableLoaderScoll=true
        this.customProfileService.batchesScreeningList(requestParams, this.searchText,this.section).subscribe((data) => {
          this.loadingData= false;
          if (data.screeningBatches?.length) {
            this.batchesScreening = this.batchesScreening.concat(data.screeningBatches);
            this.enableLoaderScoll = false;
          } else {
            this.reachedToEnd = true;
            this.enableLoaderScoll = false
          }
        }, err => {
          // this.toastrService.show('Batch list is having some error.')
          this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
            if(!toastshown){
              this.toastrService.show(res)
              toastshown=true;
            }
          })
          this.enableLoaderScoll = false;
        })
      }
    //   }, 1000);
    // }
  }
  donwloadReport(reportType) {
    let toastshown=false;
    if (reportType === 'batches_report' || reportType === 'screening_report' || reportType === 'bonded_warehouse_screening_report' ) {
      this.enableLoader = true;
      this.customProfileService.exportReport(reportType).subscribe(res => {
        if (res.code) {
          const ref = document.createElement("a");
          ref.href = `data:application/xlsx;base64,${res.code}`
          if(reportType === 'batches_report' ){
            ref.download = `BatchesReport.xlsx`
          }else if(reportType === 'screening_report'){
            ref.download = `Screening report.xlsx`
          }else if(reportType === 'bonded_warehouse_screening_report'){
            ref.download = `BW-Screening report.xlsx`
          }
          ref.click()
          this.enableLoader = false;
          this.translation.translate('shipment.downloaddoc').subscribe(res=>{
            if(!toastshown){
              this.toastrService.show(res);
              toastshown = true;
            }
          })
        }
        else {
          this.enableLoader = false;
          this.toastrService.show(res.status);
        }

      }, err => {
        this.enableLoader = false;
        this.translation.translate('shipment.downloadunsuccess').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
            toastshown = true;
          }
        })
        // this.toastrService.show('Download unsuccessful, please contact support team.');
      })
    }
  }
 openCargoAgentPopup(userType: string, list?: any){
      const modalRef = this.modalService.open(InspectionScreeningPopUpComponent, {
        centered: true,
        size: 'lg',
      });
      if(this.display === 'screening'||this.display==='bondedwarehouseScreening'){
      modalRef.componentInstance.userType = userType;
      const members = userType === 'inspection_agent'? list?.inspectionAgent?.members: list?.cargoAgent?.members;
     const agentName = userType === 'inspection_agent' ? list?.inspectionAgent?.name: list?.cargoAgent?.name;
      modalRef.componentInstance.cargoAgentMembers = members;
      modalRef.componentInstance.agentName = agentName;
     }
         else if(this.display==='delivery'){
        modalRef.componentInstance.userType = userType;
        const members = userType === 'inspection_agent'? list?.inspectionAgent?.members: list?.screeningAgent?.members;
     const agentName = userType === 'inspection_agent'? list?.inspectionAgent?.name: list?.screeningAgent?.name;
      modalRef.componentInstance.cargoAgentMembers = members;
      modalRef.componentInstance.agentName = agentName;
		 }

    }
    openInvoices(data: any){
    const modalref = this.modalService.open(AttachInvoiceComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });
    modalref.componentInstance.display='invoices';
    modalref.componentInstance.batchData = data;
    modalref.componentInstance.useCaseType = this.display === 'screening' ? 'SCREENINGINVOICE_UC3' : 'CARGODELIVERYINVOICE_UC3';

  }
    openPortInvoices(data: any){
      const modalref = this.modalService.open(PortInvoiceComponent, {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
      });
      modalref.componentInstance.display='portInvoices';
      modalref.componentInstance.batchData = data;
       modalref.componentInstance.useCaseType = this.display === 'screening' ? 'SCREENINGINVOICE_UC3' : '';
     }
  
}
